<div mat-dialog-content>
    <p class="title">Numero de identificacion</p>
    <input [(ngModel)]="identification" name="Name" type="number" class="form-control" placeholder="Numero de identificacion">
    <br>
    <br>
    <input class="boton5" type="button" value="Buscar" (click)="search()">
</div>